import { BaseMapper } from '../../../../shared/mappers/base.mapper';
import { ShippingCarrier } from '../models/shipping-carrier';

export class ShippingCarrierMapper extends BaseMapper<ShippingCarrier> {
   
}
